import {Injectable} from '@angular/core';
import {BehaviorSubject, finalize, Observable, of, switchMap, tap} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private loadingObj: {[id: number]: boolean} = {};
  private _loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private id: number = 0;

  private setLoading(value: boolean, id: number) {
    const isLoading = this.loadingObj[id];
    if (isLoading && !value) {
      //case is already loading
      delete this.loadingObj[id];
      this.removeLoadingBlurOnModals();
    }
    if (!isLoading && value) {
      //case it wasn't loading
      this.loadingObj[id] = true;
      this.addLoadingBlurOnModals();
    }
    this._loading.next(Object.values(this.loadingObj).length > 0);
  }

  getLoadingState$() {
    return this._loading.asObservable();
  }

  handleLoadingChain<T>(chain: Observable<T>) {
    const id = this.getTrackingId();
    return of(true).pipe(
      tap(() => this.setLoading(true, id)),
      switchMap(() => chain),
      finalize(() => this.setLoading(false, id)),
    );
  }

  startLoadingInstance(): number {
    const id = this.getTrackingId();
    this.setLoading(true, id);
    return id;
  }

  stopLoadingInstance(id: number) {
    if (id === null || id === undefined) {
      console.warn('Issues with loadingInstance, check your id values.');
      return;
    }
    this.setLoading(false, id);
    return;
  }

  private getTrackingId() {
    this.id = this.id + 1;
    return this.id - 1;
  }

  private addLoadingBlurOnModals() {
    const cdkOverlay = document.getElementsByClassName('cdk-overlay-container')?.item(0);
    if(!cdkOverlay) return;
    cdkOverlay.classList.add('isLoading');
  }
  private removeLoadingBlurOnModals() {
    const cdkOverlay = document.getElementsByClassName('cdk-overlay-container')?.item(0);
    if(!cdkOverlay) return;
    cdkOverlay.classList.remove('isLoading');
  }
}
